import React, {useEffect, useState} from 'react';
import {useFormik} from "formik";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField} from "@material-ui/core";
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

const EditNormativeArticleDialog = (props) => {
    const {open, onClose, submitCallback, initialValues} = props



    const onSubmit = async (values) => {
        await submitCallback(values)
    }
    

    const {getFieldProps, resetForm, submitForm, setValues} = useFormik({
        initialValues: {
            id: undefined,
            number: undefined,
            score: undefined,
            full_text: '',
            short_text: '',
            category: '',
            
        },
        onSubmit: onSubmit
    })
    

    

    const CategoryPole = [
        {category: 'TECHOLOGY', value: 'Технологические нарушения'},
        {category: 'PERSONAL', value: 'Обученность персонала , пусковая документация'},
        {category: 'ECOLOGY', value: 'Экология и ООС'},
        {category: 'INDUSTRIAL', value: 'Промышленная безопасность'},
        {category: 'ELECTO', value: 'Электробезопасность'},
        {category: 'PVO', value: 'Противофонтанная безопасность и нарушения, связанные с риском ГНВП'},
        {category: 'EQUIP', value: 'Состояние оборудования (в т.ч. ведение документации)'},
        {category: 'FIRE', value: 'Пожарная безопасность'},
        {category: 'NOTHING', value: 'Нет категории'},
    
    ]

    const handleCloseDialog = () => {
        onClose()
        resetForm()
    }

    const handleSubmitButtonClick = async () => {
        await submitForm()
        handleCloseDialog()
    }

    useEffect(() => {
        if (open && initialValues) {
            setValues(initialValues)
        }
    }, [open, initialValues])

  
    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth={"sm"} fullWidth>
            <DialogTitle>Редактирование пункта</DialogTitle>
            <DialogContent>
                <Grid container direction={'column'} spacing={2}>
                    <Grid item>
                        <TextField
                            label={'Номер пункта'}
                            fullWidth name={'number'}
                            {...getFieldProps('number')}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            label={'Рейтинг в поиске'}
                            fullWidth
                            name={'score'}
                            {...getFieldProps('score')}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            label={'Полный текст пункта'}
                            fullWidth
                            multiline
                            name={'full_text'}
                            {...getFieldProps('full_text')}
                        />
                    </Grid>
                    <Grid item>
                        <TextField
                            label={'Сокращенный текст пункта'}
                            fullWidth
                            multiline
                            name={'short_text'}
                            {...getFieldProps('short_text')}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} sm={12} >
                        <InputLabel id="demo-simple-select-label">Категория нарушения</InputLabel>
                        <Select 
                                style={{width: "100%"}}
                                labelId="demo-simple-select-label"
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                                {...getFieldProps('category')}
                                >
                                {CategoryPole.map((item, index) => <MenuItem key={index} value={item.category}>{item.value}</MenuItem> )} 
                              
                        </Select>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>
                    Отмена
                </Button>
                <Button onClick={handleSubmitButtonClick}>
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditNormativeArticleDialog;